/**
 * Generate a React Query cache key for AI teammate threads
 */
export function getThreadsQueryKey(accountAlias) {
  return ["ai-teammate-threads", accountAlias]
}

/**
 * Add a new thread to the React Query cache
 */
export function addThreadToCache(queryClient, queryKey, newThread) {
  queryClient.setQueryData(queryKey, (oldData) => {
    const oldThreads = oldData?.threads || []
    return { threads: [newThread, ...oldThreads] }
  })
}
